/** Browser compatibility guards for optional WebGL diagnostics. */

/**
 * Firefox deprecates WEBGL_debug_renderer_info and emits a console warning on
 * getExtension(). Its standard gl.RENDERER value is the supported replacement,
 * so retain the unmasked extension only for browsers that still expose it as a
 * non-deprecated diagnostic surface.
 */
export function shouldQueryWebGlDebugRendererInfo(userAgent: string): boolean {
  return !/\b(?:Firefox|FxiOS)\//i.test(userAgent);
}
